// extracted by mini-css-extract-plugin
module.exports = {"container":"Lang_container__2XipU","header":"Lang_header__1zELe","body":"Lang_body__2yiyQ"};